var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultLogoHirenest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3273 2.4571L33.3256 2.4554C32.1074 1.59839 30.4302 1.89537 29.5781 3.12065L0 45.6048L4.4055 48.7087L13.9876 34.9455C15.8217 32.3083 19.7041 32.3083 21.5399 34.9455L31.1203 48.7087L35.5258 45.6048L24.9921 30.4738C23.703 28.6223 21.6631 27.4412 19.424 27.2511L33.9921 6.22117C34.8391 4.99759 34.5421 3.31241 33.3273 2.4571Z",
    fill: "#007D6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1789 20.1192L14.4792 15.3776L5.9483 3.12318C5.09622 1.89791 3.41737 1.60092 2.20084 2.45963C0.984307 3.31495 0.687344 5.00013 1.53774 6.2254L11.1789 20.1192Z",
    fill: "#007D6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7672 0C19.441 0 21.0051 1.35764 21.0051 3.25495C21.0051 5.15566 19.441 6.51161 17.7672 6.51161C16.0951 6.51161 14.5293 5.15566 14.5293 3.25495C14.5293 1.35764 16.0951 0 17.7672 0Z",
    fill: "#007D6F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogoHirenest);
export default __webpack_public_path__ + "static/media/defaultLogoHirenest.164cf375de9503231034fa0b121e85b4.svg";
export { ForwardRef as ReactComponent };